import { observable } from 'mobx';

export type HotelStayPlanResponseArgs = {
  id: string;
  name?: string | null;
  room_name?: string | null;
  restricted?: boolean | null;
};

export type HotelStayPlanArgs = {
  id: string;
  name?: string | null;
  roomName?: string | null;
  restricted?: boolean | null;
};

export const convertHotelStayPlanResponseToArgs = (response: HotelStayPlanResponseArgs) => {
  const args: HotelStayPlanArgs = {
    id: response.id,
    name: response.name,
    roomName: response.room_name,
    restricted: response.restricted
  };
  return args;
};

export default class HotelStayPlan {
  @observable id: string;
  @observable name?: string | null;
  @observable roomName?: string | null;
  @observable restricted?: boolean | null;

  constructor(args: HotelStayPlanArgs) {
    this.id = args.id;
    this.name = args.name;
    this.roomName = args.roomName;
    this.restricted = args.restricted;
  }
}
